import { IS_PROD } from './config';

export const SEVEN_DAYS_MS = 7 * 24 * 60 * 60 * 1000;

export const GLADLY_URL = IS_PROD
  ? 'https://spotandtango.us-1.gladly.com/'
  : 'https://spotandtango.us-uat.gladly.qa/';
